/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputPositionShort } from './OutputPositionShort';
import {
    OutputPositionShortFromJSON,
    OutputPositionShortFromJSONTyped,
    OutputPositionShortToJSON,
} from './OutputPositionShort';

/**
 * 
 * @export
 * @interface OutputTeamSessionInfo
 */
export interface OutputTeamSessionInfo {
    /**
     * 
     * @type {string}
     * @memberof OutputTeamSessionInfo
     */
    expiresAt: string;
    /**
     * 
     * @type {number}
     * @memberof OutputTeamSessionInfo
     */
    id: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof OutputTeamSessionInfo
     */
    pilots: { [key: string]: string; };
    /**
     * 
     * @type {OutputPositionShort}
     * @memberof OutputTeamSessionInfo
     */
    position?: OutputPositionShort;
    /**
     * 
     * @type {string}
     * @memberof OutputTeamSessionInfo
     */
    startsAt: string;
    /**
     * 
     * @type {string}
     * @memberof OutputTeamSessionInfo
     */
    status: string;
}

/**
 * Check if a given object implements the OutputTeamSessionInfo interface.
 */
export function instanceOfOutputTeamSessionInfo(value: object): boolean {
    if (!('expiresAt' in value)) return false;
    if (!('id' in value)) return false;
    if (!('pilots' in value)) return false;
    if (!('startsAt' in value)) return false;
    if (!('status' in value)) return false;
    return true;
}

export function OutputTeamSessionInfoFromJSON(json: any): OutputTeamSessionInfo {
    return OutputTeamSessionInfoFromJSONTyped(json, false);
}

export function OutputTeamSessionInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputTeamSessionInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'expiresAt': json['expiresAt'],
        'id': json['id'],
        'pilots': json['pilots'],
        'position': json['position'] == null ? undefined : OutputPositionShortFromJSON(json['position']),
        'startsAt': json['startsAt'],
        'status': json['status'],
    };
}

export function OutputTeamSessionInfoToJSON(value?: OutputTeamSessionInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'expiresAt': value['expiresAt'],
        'id': value['id'],
        'pilots': value['pilots'],
        'position': OutputPositionShortToJSON(value['position']),
        'startsAt': value['startsAt'],
        'status': value['status'],
    };
}

